import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { AttachmentLoader } from 'shared/ui/Loader'
import { checkCDN } from 'shared/lib/checkCDN'
import { getAriaLabel } from 'shared/lib'
import { Avatar } from 'shared/ui'
import { type Attachment } from 'entities/Attachment/model/Attachment'
import styles from './styles.module.scss'

type Props = {
  attachment?: Attachment
  file?: File
  loading?: boolean
  onCardClick?: () => void
  small?: boolean
  medium?: boolean
  fullWidth?: boolean
  thumbnail?: boolean
  imgFitType?: 'cover' | 'contain'
  onLoad?: () => void
  className?: string
}

const exceptExtension = ['vcf']

export const ImageCard: FC<Props> = observer(
  ({
    attachment,
    onCardClick,
    fullWidth,
    small,
    thumbnail,
    medium,
    file,
    loading,
    imgFitType = 'cover',
    onLoad,
    className,
  }) => {
    const attachmentSource =
      attachment && thumbnail && attachment.thumbnail ? attachment.thumbnail : attachment?.source

    const isNoImage =
      attachmentSource && exceptExtension.includes(attachmentSource.split('.').pop() || '')
    return (
      <div
        className={classNames(styles.wrap, className, {
          [styles.small]: small,
          [styles.medium]: medium,
          [styles.fullWidth]: fullWidth,
          [styles.thumbnail]: thumbnail,
          [styles.clickable]: Boolean(onCardClick),
        })}
        onClick={onCardClick}
        aria-hidden={true}
        aria-label={getAriaLabel('ImageCard')}
      >
        <div
          className={classNames(styles.imgContainer, styles.img, {
            [styles.isNoImage]: isNoImage,
          })}
          aria-label={getAriaLabel('ImageCard', 'img')}
        >
          {isNoImage ? (
            <Avatar
              size={32}
              info={{
                icon: 'personFilled',
                color: 'var(--gray-60)',
              }}
              iconProps={{ fontSize: 20 }}
            />
          ) : (
            <img
              src={attachment ? attachmentSource : file && URL.createObjectURL(file)}
              alt=''
              style={{
                objectFit: imgFitType,
              }}
              {...(checkCDN(attachmentSource) ? { crossOrigin: 'use-credentials' } : null)}
              onLoad={onLoad}
            />
          )}
        </div>
        {loading && <AttachmentLoader />}
      </div>
    )
  }
)
